import { Link } from 'react-router-dom';
import type { CartItem } from '../../../hooks/useCart';

interface Props {
  items: CartItem[];
  onRemove: (id: string) => void;
  onUpdateQty: (id: string, qty: number) => void;
  onNext: () => void;
}

export default function CartStep({ items, onRemove, onUpdateQty, onNext }: Props) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-black text-gray-900">سلة التسوق</h2>
        {items.length > 0 && (
          <span className="bg-[#C9A961]/10 text-[#C9A961] text-xs font-bold px-3 py-1 rounded-full">
            {items.length} منتج
          </span>
        )}
      </div>

      {items.length === 0 ? (
        <div className="text-center py-16">
          <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 bg-gray-50 rounded-full">
            <i className="ri-shopping-bag-line text-4xl text-gray-300" />
          </div>
          <p className="text-gray-500 mb-2 font-semibold">سلتك فارغة</p>
          <p className="text-gray-400 text-sm mb-6">أضف منتجات من المتجر وارجع هنا للدفع</p>
          <Link
            to="/products"
            className="inline-flex items-center gap-2 bg-[#C9A961] text-white px-7 py-3 rounded-full font-bold cursor-pointer whitespace-nowrap hover:bg-[#A07C30] transition-colors"
          >
            <i className="ri-store-2-line" />
            تصفح المنتجات
          </Link>
        </div>
      ) : (
        <>
          <div className="space-y-3 mb-6">
            {items.map(item => (
              <div
                key={item.id}
                className="flex items-center gap-4 p-4 bg-[#FAFAF8] rounded-xl border border-gray-100 group"
              >
                {/* Image */}
                <div className="w-20 h-20 rounded-xl overflow-hidden flex-shrink-0 border border-gray-100">
                  <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                </div>

                {/* Info */}
                <div className="flex-1 min-w-0 text-right">
                  <h4 className="font-bold text-gray-900 text-sm mb-1 truncate">{item.name}</h4>
                  <div className="flex items-center gap-1">
                    <span className="text-[#C9A961] font-black text-base">{item.price}</span>
                    <span className="text-gray-400 text-xs">د.إ / قطعة</span>
                  </div>
                </div>

                {/* Qty */}
                <div className="flex items-center gap-1 bg-white rounded-xl border border-gray-200 p-1">
                  <button
                    onClick={() => onUpdateQty(item.id, item.quantity - 1)}
                    className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-[#C9A961] hover:text-white transition-colors cursor-pointer text-gray-500"
                  >
                    <i className="ri-subtract-line text-sm" />
                  </button>
                  <span className="w-7 text-center font-black text-sm text-gray-900">{item.quantity}</span>
                  <button
                    onClick={() => onUpdateQty(item.id, item.quantity + 1)}
                    className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-[#C9A961] hover:text-white transition-colors cursor-pointer text-gray-500"
                  >
                    <i className="ri-add-line text-sm" />
                  </button>
                </div>

                {/* Total & delete */}
                <div className="flex flex-col items-end gap-2 flex-shrink-0">
                  <span className="text-gray-900 font-black text-sm">{(item.price * item.quantity).toFixed(0)} د.إ</span>
                  <button
                    onClick={() => onRemove(item.id)}
                    className="w-7 h-7 flex items-center justify-center text-gray-300 hover:text-red-500 transition-colors cursor-pointer"
                  >
                    <i className="ri-delete-bin-line text-base" />
                  </button>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={onNext}
            className="w-full flex items-center justify-center gap-3 bg-[#C9A961] text-white py-4 rounded-xl font-black text-base cursor-pointer hover:bg-[#A07C30] transition-colors whitespace-nowrap"
          >
            <span>متابعة لبيانات التوصيل</span>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line text-lg" />
            </div>
          </button>
        </>
      )}
    </div>
  );
}
